module.exports = __webpack_public_path__ + "img/20191209120807065.8a593a30.jpeg";